import {combineEpics, ofType, PledgerAction, PledgerEpic} from "@pledger/frontend-commons";

import {CreateSouscriptionActions} from "../CreateSouscriptionActions";
import {CurrentModuleId} from "../CurrentModuleId";
import {map} from "rxjs/operators";
import {souscriptionCGPWServiceActions} from "../../../services/ws/SouscriptionCGP/souscriptionCGPWServiceActions";


const simulationCreatedEpic : PledgerEpic<any> = (actions$) =>
    actions$.pipe(
        ofType(souscriptionCGPWServiceActions.CREATE_SOUSCRIPTION_CGP_SIMULATION_SUCCEEDED_ACTION.type),
        map((action : PledgerAction) => {
            return CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.build(CurrentModuleId.CGP_TUNNEL);
        }));
export const souscriptionCGPEpics = combineEpics(
    simulationCreatedEpic,
);
